const addrComponentsToRecord = (addressComponents) => (addressComponents == null ? void 0 : addressComponents.reduce((acc, item) => {
  for (const cType of item.types)
    acc[cType] = item;
  return acc;
}, {})) ?? {};
export {
  addrComponentsToRecord
};
//# sourceMappingURL=addrComponentsToRecord.js.map
